import { Link, useParams } from 'react-router-dom'

import { PressReleaseLayout } from '@/components/marketing/press-release-layout'
import { pressReleaseBySlug } from '@/config/marketing-content/press-releases.generated'

export function PressReleasePage() {
  const { slug } = useParams<{ slug: string }>()
  const release = slug ? pressReleaseBySlug[slug] : undefined

  if (!release) {
    return (
      <main className="press-release">
        <div className="marketing-container">
          <h1 className="press-release__title">Press release not found</h1>
          <p className="press-release__subtitle">
            The release you are looking for is unavailable.
          </p>
          <Link to="/newsroom" className="press-release__back-link">
            Back to Newsroom
          </Link>
        </div>
      </main>
    )
  }

  return <PressReleaseLayout release={release} />
}
